import { useMemo } from 'react';
import { shallow } from 'zustand/shallow';
import useBoundStore from 'store';
import { MarketTypes } from 'api/types';

export type ApartmentFilters = {
  apartmentComplexIds: number[];
  priceFrom: number | undefined;
  priceTo: number | undefined;
  areaFrom: number | undefined;
  areaTo: number | undefined;
  marketPriceFrom: number | undefined;
  marketPriceTo: number | undefined;
  differenceWithMarketPrice: number | undefined;
  facilityTypeIds: number[];
  planIds: number[];
  marketType?: MarketTypes;
};

const useApartmentsFilterQuery = (): ApartmentFilters => {
  const storeParams = useBoundStore(
    ({
      selectedComplexes,
      priceRange,
      pricePerSqMRange,
      areaSqFootageRange,
      marketPriceRange,
      selectedApartmentRoomTypes,
      selectedRoomTypes,
      diffWithMarketPrice,
      selectedApartmentPlan,
      selectedPolygon,
    }) => ({
      selectedComplexes,
      priceRange,
      pricePerSqMRange,
      marketPriceRange,
      areaSqFootageRange,
      selectedApartmentRoomTypes,
      selectedRoomTypes,
      diffWithMarketPrice,
      selectedApartmentPlan,
      selectedPolygon,
    }),
    shallow,
  );

  const filter = useMemo(() => {
    const {
      selectedComplexes,
      priceRange,
      pricePerSqMRange,
      areaSqFootageRange,
      marketPriceRange,
      selectedApartmentRoomTypes,
      selectedRoomTypes,
      selectedApartmentPlan,
      selectedPolygon,
      diffWithMarketPrice,
    } = storeParams;

    return {
      apartmentComplexIds: [...selectedComplexes.values()],
      priceFrom: priceRange.min,
      priceTo: priceRange.max,
      areaFrom: areaSqFootageRange.min,
      areaTo: areaSqFootageRange.max,
      marketPriceFrom: marketPriceRange.min,
      marketPriceTo: marketPriceRange.max,
      pricePerSqMFrom: pricePerSqMRange.min,
      pricePerSqMTo: pricePerSqMRange.max,
      differenceWithMarketPrice: diffWithMarketPrice,
      facilityTypeIds:
        selectedApartmentRoomTypes.size !== 0
          ? [...selectedApartmentRoomTypes.values()]
          : [...selectedRoomTypes.values()],
      planIds: [...selectedApartmentPlan.values()],
      buildingAddressSearchPoligons: selectedPolygon?.map((polygon) => polygon.coords),
    };
  }, [storeParams]);

  return filter;
};

export default useApartmentsFilterQuery;
